// extracted by mini-css-extract-plugin
export default {"success":"Success_success__IKf7R","icon":"Success_icon__O05aY","info":"Success_info__6Gwub","price":"Success_price__begC6","text":"Success_text__qF00-"};